import { render, staticRenderFns } from "./Ride.vue?vue&type=template&id=1355445e&scoped=true&"
import script from "./Ride.vue?vue&type=script&lang=js&"
export * from "./Ride.vue?vue&type=script&lang=js&"
import style0 from "./Ride.vue?vue&type=style&index=0&id=1355445e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355445e",
  null
  
)

export default component.exports